import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import dayjs from 'dayjs';
import { toast } from 'react-hot-toast';
import { getApi, postApi } from '../../ApiServices/api';
import { apiEndPoints } from '../../ApiServices/config';
import { addToCart, updateCart, removeFromCart, clearCart } from '../../actions/index';
import { useForm } from 'react-hook-form';
import { getCurrentDateWithAdjustedTime } from '../../utils/utils';
import { useLocation } from 'react-router-dom';

export const useCart = () => {
  const [makeDonationChecked, setMakeDonationChecked] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [expanded, setExpanded] = React.useState({});
  const [donationData, setDonationsData] = useState();
  const [donationItem, setDonationItem] = useState();
  const [donationAmount, setDonationAmount] = useState([]);
  const [quantityCounts, setQuantityCounts] = useState({});
  const [selectedDate, setSelectedDate] = useState({});
  const [error, setError] = useState('');
  const cartArr = useSelector((state) => state.cartArr);
  const isDevoteeLoggedIn = localStorage.getItem('token');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { control } = useForm({});
  const bookingType = 'payment'; // we have oly booking type for service at temple  1. request 2. payment
  const serivceType = 'servicesAtTemple'; // It can we  1. servicesOutsideTemple  2. servicesAtTemple 3. rental 4. lotusAcademy
  const location = useLocation();
  const serviceName = location.pathname.split('/')[1];

const normalizeDate = (date) => dayjs(date).format('YYYY-MM-DD');

  const validateItem = async (itemType, item) => {
    if (itemType.toLowerCase() !== 'donations' && itemType.toLowerCase() !== 'kitchen') {
      if (item.booking_config === 'Online booking not available call temple to book') {
        const response = await postApi(apiEndPoints.getBookingConfigByTitle, {
          title: item.booking_config
        });
        toast.error(response.data.data.data.message);
        return false;
      }
      if (item.amount == 0) {
        toast.error("You can't book this puja. For more information, please contact the temple.");
        return false;
      }
      if (!selectedDate[item._id]) {
        toast.error('Please select a date for the Puja.');
        return false;
      }
    }
    return true;
  };

const updateReduxQuantity = (itemId, newQuantity, date) => {
  const normalizedDate = normalizeDate(date);

  const existingCartItem = cartArr.find(
    (cartItem) =>
      cartItem._id === itemId &&
      normalizeDate(cartItem.selectedDate) === normalizedDate
  );

  if (existingCartItem && newQuantity > 0) {
    dispatch(
      updateCart({
        ...existingCartItem,
        quantity: newQuantity
      })
    );
  }
};

const increaseQuantity = (itemId, date) => {
  const normalizedDate = normalizeDate(date);
  const key = `${itemId}|${normalizedDate}`;

  const cartItem = cartArr.find(
    (item) =>
      item._id === itemId &&
      normalizeDate(item.selectedDate) === normalizedDate
  );

  const currentQuantity =
    quantityCounts[key] ?? cartItem?.quantity ?? 1;

  const newQuantity = currentQuantity + 1;

  setQuantityCounts((prev) => ({
    ...prev,
    [key]: newQuantity
  }));

  updateReduxQuantity(itemId, newQuantity, normalizedDate);
};


const decreaseQuantity = (itemId, date) => {
  const normalizedDate = normalizeDate(date);
  const key = `${itemId}|${normalizedDate}`;

  const cartItem = cartArr.find(
    (item) =>
      item._id === itemId &&
      normalizeDate(item.selectedDate) === normalizedDate
  );

  const currentQuantity =
    quantityCounts[key] ?? cartItem?.quantity ?? 1;

  if (currentQuantity <= 1) return;

  const newQuantity = currentQuantity - 1;

  setQuantityCounts((prev) => ({
    ...prev,
    [key]: newQuantity
  }));

  updateReduxQuantity(itemId, newQuantity, normalizedDate);
};


const addItem = async (itemType, item) => {
  if (itemType.toLowerCase() === 'donations') {
    const formateDate = normalizeDate(
      dayjs.utc(getCurrentDateWithAdjustedTime(dayjs()))
    );

    const inputAmount =
      donationAmount[item._id] != null
        ? Number(donationAmount[item._id])
        : Number(item.amount);

    if (!inputAmount || isNaN(inputAmount) || inputAmount <= 0) {
      toast.error('Please enter a valid donation amount greater than 0');
      return;
    }

    if (
      item?.amount &&
      Number(item.amount) > 0 &&
      inputAmount < Number(item.amount)
    ) {
      toast.error(
        `Donation amount must be greater than or equal to donation minimum amount ($${item.amount})`
      );
      return;
    }

    const existingCartItem = cartArr.find(
      (cartItem) =>
        cartItem._id === item._id &&
        normalizeDate(cartItem.selectedDate) === formateDate
    );

    const key = `${item._id}|${formateDate}`;

    if (existingCartItem) {
      const newQuantity = existingCartItem.quantity + 1;

      setQuantityCounts((prev) => ({
        ...prev,
        [key]: newQuantity
      }));

      dispatch(
        updateCart({
          ...existingCartItem,
          quantity: newQuantity,
          amount: inputAmount,
          selectedDate: formateDate
        })
      );

      toast.success(
        'Your puja/donation has been successfully updated to the puja basket.'
      );
    } else {
      setQuantityCounts((prev) => ({
        ...prev,
        [key]: 1
      }));

      dispatch(
        addToCart({
          ...item,
          type_id: 1,
          quantity: 1,
          amount: inputAmount,
          itemType: itemType,
          selectedDate: formateDate
        })
      );

      toast.success(
        'Your puja/donation has been successfully added to the puja basket.'
      );
    }
  } 
  // ================= SERVICES =================
  else {
    if (!selectedDate[item._id]) return;

    const formateDate = normalizeDate(selectedDate[item._id]);
    const key = `${item._id}|${formateDate}`;

    const existingCartItem = cartArr.find(
      (cartItem) =>
        cartItem._id === item._id &&
        normalizeDate(cartItem.selectedDate) === formateDate
    );

    if (existingCartItem) {
      const newQuantity = existingCartItem.quantity + 1;

      setQuantityCounts((prev) => ({
        ...prev,
        [key]: newQuantity
      }));

      dispatch(
        updateCart({
          ...existingCartItem,
          quantity: newQuantity,
          selectedDate: formateDate
        })
      );

      toast.success(
        'Your puja/donation has been successfully updated to the puja basket.'
      );
    } else {
      setQuantityCounts((prev) => ({
        ...prev,
        [key]: 1
      }));

      dispatch(
        addToCart({
          ...item,
          type_id: 1,
          quantity: 1,
          amount: item.amount,
          itemType: itemType,
          selectedDate: formateDate
        })
      );

      toast.success(
        'Your puja/donation has been successfully added to the puja basket.',
        { id: 'Service At Temple' }
      );
    }
  }
};


  const handleChildrenRemove = (item) => {
    dispatch(removeFromCart({ _id: item._id, selectedDate: item.selectedDate }));
    toast.success('Item removed from the Basket');
  };

  const handleEmptyPoojaBasket = () => {
    dispatch(clearCart());
  };

  const handleProceedToPay = () => {
    if (cartArr.length === 0) {
      toast.error('Puja basket is empty, add services/donations before payment', {});
    } else {
      navigate(`/${serviceName === 'services' || 'donation' ? serivceType : serviceName}/${bookingType}`);
    }
  };

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded((prev) => ({
      ...prev,
      [panel]: newExpanded ? panel : false
    }));
  };

  const getAllDonations = async () => {
    const response = await getApi(apiEndPoints.getAllDonations);
    if (response && response.status === 200) {
      setDonationsData(response?.data?.data);
      setDonationItem(response?.data?.data[0]);
    }
  };

  const handleAddDonations = () => {
    let formateDate = dayjs.utc(getCurrentDateWithAdjustedTime(dayjs()));
    if (Number(donationAmount) === 0) {
      toast.error('Donation amount must be greater than 0');
    } else if (Number(donationAmount) < donationItem?.amount) {
      toast.error('Donation amount must be greater than or equal to donation minimum amount');
    } else {
      const existingCartItem = cartArr.find((cartItem) => cartItem._id === donationItem._id);

      if (existingCartItem) {
        const updatedItem = {
          ...existingCartItem,
          amount: Number(donationAmount),
          selectedDate: formateDate,
          itemType: 'donations',
          type_id: 5,
          location: '',
          page: 'services/donation'
        };
        dispatch(updateCart(updatedItem));
        toast.success('Your puja/donation is updated');
        setDonationAmount(0);
        setDonationItem(donationData[0]);
        setMakeDonationChecked(false);
      } else {
        const newItem = {
          ...donationItem,
          amount: Number(donationAmount),
          type_id: 5,
          itemType: 'donations',
          selectedDate: formateDate,
          location: '',
          page: 'services/donation'
        };
        dispatch(addToCart(newItem));
        setDonationAmount(0);
        setDonationItem(donationData[0]);
        setMakeDonationChecked(false);
      }
    }
  };

  const handleInputChange = (e) => {
    const input = e.target.value;
    const regex = /^[0-9]*\.?[0-9]*$/;

    if (regex.test(input)) {
      setDonationAmount(input);
      setError('');
    } else {
      setDonationAmount(input);
      setError('Only numeric values are allowed (no symbols or letters).');
    }
  };

  return {
    makeDonationChecked,
    setMakeDonationChecked,
    cartArr,
    totalAmount,
    setTotalAmount,
    expanded,
    setExpanded,
    donationData,
    setDonationsData,
    donationItem,
    setDonationItem,
    error,
    setError,
    control,
    selectedDate,
    setSelectedDate,
    quantityCounts,
    setQuantityCounts,
    donationAmount,
    setDonationAmount,
    validateItem,
    addItem,
    increaseQuantity,
    decreaseQuantity,
    handleChildrenRemove,
    handleEmptyPoojaBasket,
    handleProceedToPay,
    handleChange,
    getAllDonations,
    handleAddDonations,
    handleInputChange
  };
};
